module.exports = __webpack_public_path__ + "static/logo-cdb6e444f2293720d5945c21bb8a9f25.png";